import FormField from "./FormField";
import { classNames, colors } from "tools/ui";
import upStore from "store/upStore";

const style =
  "h-10 rounded-md shadow-sm w-full text-right py-2 px-3 text-gray-700 border border-slate-300 focus:outline-none focus:border focus:border-cyan-500";

const PATTERN = /^-?\d*\.?\d{0,6}$/;
const formatter = Intl.NumberFormat("en-US");

function NumericField(props) {
  const { field, attrs, data } = props;
  const { name, readOnly, decimalPlaces, rounded = false, whitoutOnBlur = false } = field;
  const { level } = attrs;

  function onChange(event) {
    let _value = event.target.value;
    _value = _value.replaceAll(",", "");
    const validNumber = PATTERN.test(_value);

    if (!validNumber) {
      return;
    }
    data.value = _value;
    if (whitoutOnBlur) {
      upStore(level, {
        fieldName: name,
        value: _value,
        field: field,
      });
    }
  }

  const onBlur = () => {
    let _value;
    if (data.value && data.value !== "") {
      _value = data.value.replaceAll(",", "");
      _value = parseFloat(_value).toFixed(decimalPlaces || 0);
      _value = _value.toString();
    } else {
      _value = 0;
    }
    data.value = formatter.format(_value);
    upStore(level, {
      fieldName: name,
      value: _value,
      valueActive: data.value,
      field: field,
    });
  };

  const _color = readOnly ? colors.readOnly : props.color ?? "bg-white";

  let moreTools;
  if (field.format && field.format === "percent") {
    moreTools = <p className="pl-2 my-auto text-stone-700 text-sm">%</p>;
  }
  if (rounded && data?.value) {
    const _value = Math.round(parseFloat(data?.value.replace(/,/g, "")) || 0);
    data.value = formatter.format(_value);
  }

  return (
    <FormField {...field}>
      <div className="flex">
        <input
          id={name}
          type="text"
          name={name}
          className={classNames(style, _color)}
          value={data?.value}
          onChange={onChange}
          onBlur={whitoutOnBlur ? undefined : onBlur}
          disabled={readOnly}
          placeholder={field.placeholder ?? ""}
        />
        {field.icon || null}
        {moreTools}
      </div>
    </FormField>
  );
}

export default NumericField;
